export default function getSortedFavoriteLists(lists) {
  if (!lists || !lists.length) {
    return [];
  }

  const defaultList = lists.find(list => list.is_default) || [];
  const nonDefaultLists = lists.filter(list => !list.is_default);
  return [].concat(defaultList, nonDefaultLists);
}
